import { render, staticRenderFns } from "./fansRecord.vue?vue&type=template&id=4a2b2ded&scoped=true"
import script from "./fansRecord.vue?vue&type=script&lang=js"
export * from "./fansRecord.vue?vue&type=script&lang=js"
import style0 from "./fansRecord.vue?vue&type=style&index=0&id=4a2b2ded&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b2ded",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a2b2ded')) {
      api.createRecord('4a2b2ded', component.options)
    } else {
      api.reload('4a2b2ded', component.options)
    }
    module.hot.accept("./fansRecord.vue?vue&type=template&id=4a2b2ded&scoped=true", function () {
      api.rerender('4a2b2ded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/userManagement/components/fansRecord.vue"
export default component.exports